import { NullableDate, NullableNumber, NullableString } from "@/code/Types";
import { BaseClientDocument } from "./BaseDocuments";

export class ClientData extends BaseClientDocument {
  clientFullName: NullableString = null;
  clientFirstName: NullableString = null;
  clientMiddleName: NullableString = null;
  clientLastName: NullableString = null;
  clientDateOfBirth: NullableDate = null;
  clientAge: NullableNumber = null;
  clientGender: NullableString = null;
  newBusinessNumber: NullableNumber = null;
  existingPolicies: NullableNumber = null;
}
